window.SpvAllocationRequests = {}